var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.conditions
    ? _c(
        "ob1-popin-modal2",
        {
          attrs: { id: _vm.modalId, "aria-labelledby": _vm.modalId + "-modal" },
        },
        [
          _c("h4", [_vm._v("Le bonus reprise")]),
          _vm._v(" "),
          _c("div", { staticClass: "bg-greige px-1 my-1 my-md-2" }, [
            _c("p", { staticClass: "mb-0" }, [
              _c("strong", [
                _vm._v(
                  "Lors du rachat de votre ancien mobile, on ajoute un bonus au prix de reprise estimé."
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "px-1" }, [
            _c("p", { staticClass: "mb-0" }, [
              _c("strong", [_vm._v("Par exemple :")]),
            ]),
            _vm._v(" "),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.exampleTextHtml) } }),
            _vm._v(" "),
            _c("p", {
              staticClass: "small",
              domProps: { innerHTML: _vm._s(_vm.conditions) },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "small" }, [
              _vm._v(
                "\n            *Valeur à titre d’exemple. La valeur réelle de votre mobile actuel est déterminée en fonction du modèle et de son état.\n        "
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }